import { en } from 'vuetify/locale';
import designerI18n from './designer-i18n.js';

export default {
    welcome: "Welcome",
    login: "Log in",
    logout: "Log out",
    about: "About",
    dashboard: "Dashboard",
    products: "Products",
    users: "Users",
    labels: "Labels",
    createUser: "Create user",
    editUser: "Edit user",
    deleteUser: "Delete user",
    userList: "User list",
    productList: "Product list",
    createProduct: "Create product",
    editProduct: "Edit product",
    deleteProduct: "Delete product",
    labelSettings: "Label settings",
    createCategory: "Create category",
    editCategory: "Edit category",
    deleteCategory: "Delete category",
    categoryList: "Category list",
    dragToReorder: "Drag to reorder the categories",
    name: "Name",
    nameFormat: "Name (First Last)*",
    email: "Email",
    emailFormat: "Email*",
    role: "Is admin",
    actions: "Actions",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    confirmDelete: "Are you sure you want to delete this item?",
    yes: "Yes",
    no: "No",
    search: "Search...",
    itemsPerPageText: "Items per page:",
    pageText: "{0}-{1} of {2}",
    productName: "Product name*",
    productNumber: "Product number",
    productOnList: "Product name",
    category: "Category",
    categoryOnList: "Category",
    categories: "Categories",
    noCategories: "No categories",
    thawingDays: "Thawing (days)",
    notesHint: "Additional information about this product",
    refridgeDays: "Refrigerated (days)",
    threeHoursHint: "Can the product be left out for 3 hours?",
    allergens: "Allergens",
    selectAllergens: "Select allergens",
    noAllergens: "No allergens",
    notes: "Note",
    daysUntilExpiration: "Days until expiry",
    daysNeededForThawing: "Days needed for thawing",
    daysInRefrigeration: "Days in refrigeration",
    producedDateLabel: "Production date",
    openedDateLabel: "Opened date",
    createdAt: "Created at",
    updatedAt: "Updated at",
    expirationDate: "Expiry date",
    openedDate: "Opened date",
    producedDate: "Production date",     
    numLabels: "Number of labels",
    quantity: "Quantity",
    foodItems: "Products",
    printSelected: "Print selected",
    mandatoryField: "indicates a required field",
    categoryName: "Category name*",
    description: "Description",
    descriptionHint: "Line break with Enter",
    standardCategory: "Default category",
    fieldRequired: "Field is required",
    standard: "Default",
    devices: "Devices",
    deviceNick: "Device nickname",
    deviceID: "Device ID",
    confirmDeleteDevice: "Are you sure you want to delete the device:",
    userAdministration: "User administration",
    newPasswordOptional: "New password (optional)",
    passwordFormat: "Password*",
    password: "Password",
    admin: "Administrator",
    printFooditems: "Print labels",
    fromFooditems: "from food items",
    loadingHomepage: "Loading homepage...",
    pleaseLogin: "Please log in to access the homepage",
    settings: "Settings",
    displaySettings: "Display settings",
    theme: "Theme",
    light: "Light",
    dark: "Dark",
    language: "Language",  
    selectLanguage: "Select language",
    finnish: "Finnish",
    danish: "Danish",
    english: "English",
    swedish: "Swedish",
    norweigian: "Norwegian",
    german: "German",
    japaneese: "Japanese",
    selectedLabel: "Selected label",
    dataManagement: "Data management",
    importData: "Import data",
    exportData: "Export data",
    importExport: "Import / Export",
    exportProducts: "Export products",
    importProducts: "Import products",
    selectFile: "Select file",
    upload: "Upload",
    download: "Download",
    dataImportSuccess: "Data imported successfully",
    dataImportError: "Error importing data",
    importProductsSubtitle: "Import products from an xlsx file.",
    useCategories: "Show categories",
    defaultLabel: "Default label",
    defaultLabelHint: "Choose the label preselected when printing labels.",
    noLabelsAvailable: "No labels available",
    copy: "Copy",
    useAliasAsTitle: "Use alias as title",
    useAliasAsTitleHint: "Use the 'Alias' field instead of 'Product name'. If 'Alias' is empty, 'Product name' is used as a fallback.",
    menus: "Menus",
    locations: "Locations",
    deleteSelected: "Delete selected",
    confirmDeleteSelected: "Are you sure you want to delete {count} products?",
    create: "Create",
    createNewCategory: "Create new category",
    nutritionProfile: "Nutrition profile",
    nutritionProfileHint: "Used by the nutrition element on labels.",
    noNutritionProfiles: "No nutrition profiles yet",
    days: "Days",
    hours: "Hours",
    alias: "Alias",
    barcode: "Barcode",

    // Label Designer
    labelDesigner: "Label designer",
    saveLabel: "Save label",
    refresh: "Refresh",
    selectLabel: "Select label",
    createNewLabel: "Create new label",
    labelName: "Label name",
    width: "Width (mm)",
    height: "Height (mm)",
    titleFont: "Title font (pt)",
    titleX: "Title X (mm)",
    titleY: "Title Y (mm)",
    active: "Active",
    addField: "Add field",
    fieldType: "Field type",
    labelText: "Field text",
    baseDate: "Base date",
    offsetField: "Offset field",
    databaseField: "Database field",
    xPosition: "X position (mm)",
    yPosition: "Y position (mm)",
    fontSize: "Font size (pt)",
    qrSize: "QR code size (mm)",
    preview: "Preview",
    sampleItemName: "Sample product name",
    size: "Size",
    scale: "Scale",
    fieldsCount: "Fields",
    newLabel: "New label",
    newField: "New field",
    labelSaved: "Label saved!",
    loadLabelsFailed: "Could not load labels",
    saveLabelFailed: "Could not save label",
    labelPrinting: "Label printing",
    productsPerPage: "Items per page",
    showAll: "Show all",
    selectAtLeastOne: "Please select at least one item.",
    noLabelSelected: "No label selected. Please choose one in settings.",
    labelColor: "Label colour",
    creditZplImage: "ZPL image plugin developed by: ",
    fieldTypePrompt: "Input prompt",
    promptDialogTitle: "Input",

    // Label Type
    labelType: "Label type",
    labelTypeStandard: "Default",
    labelTypeFreetext: "Free text",
    freetextNotice: "Free-text labels are blank fields for typing directly on the tablet. No product name or predefined fields are shown.",

    // Logo
    logo: "Logo",
    logoReplace: "Replace",
    logoUpload: "Upload",
    logoRemove: "Remove",
    logoNoLogo: "No logo uploaded. Add one to place it on the label.",
    logoUploadTitle: "Upload logo",
    logoSelectFile: "Select PNG image",
    logoSelectFileHint: "Upload the image already rotated, exactly as you want it printed.",
    logoWidthOnLabel: "Width on label (mm)",
    logoWidthHint: "Height is calculated automatically",
    logoPrinterDpi: "Printer DPI",
    logoOriginal: "Original",
    logoTarget: "Target",
    logoBlackThreshold: "Black threshold",
    logoBlackThresholdHint: "Lower = only dark pixels turn black. Higher = lighter pixels turn black too.",
    logoPreviewOriginal: "Original",
    logoPreviewMono: "Monochrome (as printed)",
    logoApply: "Apply",
    logoLoaded: "Logo loaded ({width}×{height}mm). Use X/Y below to place it on the label.",
    logoNotUploaded: "No logo uploaded yet. Go to Label settings → Logo to upload one.",
    logoUploaded: "Logo uploaded and converted",
    logoUploadFailed: "Could not upload logo",
    logoProcessFailed: "Could not process logo",
    logoInvalidDimensions: "Invalid dimensions",
    logoNoFile: "No file selected",

    // Field Types (dropdown titles)
    fieldTypeDate: "Date",
    fieldTypeDatePlus: "Date + days",
    fieldTypeDatabase: "Database field",
    fieldTypeQrcode: "QR code",
    fieldTypeBarcode: "Barcode (Code128)",
    fieldTypeLogo: "Logo image",
    fieldTypeValueOnly: "Value only (floating)",
    fieldTypeAllergensText: "Allergen text",
    fieldTypeStatic: "Static text",
    fieldTypeDivider: "Divider",

    // Value Only sub-types
    valueType: "Value type",
    valueTypeDate: "Date",
    valueTypeDatePlus: "Date + days",
    valueTypeDatabase: "Database field",

    // Field position & size labels
    xMm: "X (mm)",
    yMm: "Y (mm)",
    rotation: "Rotation",

    // Separator & value position
    separator: "Separator",
    separatorHint: "Text between label and value. Leave empty for no separator.",
    separatorPlaceholder: ": ",
    valueXMm: "Value X (mm)",
    valueXHint: "Leave empty to place after the label",
    valueYMm: "Value Y (mm)",
    valueYHint: "Leave empty to use the label's Y",
    valueFontSize: "Value font size",
    valueFontSizeHint: "Leave empty to use the label's size",

    // Font style
    bold: "Bold",
    italic: "Italic",

    // Text alignment
    textAlignment: "Text alignment",
    alignLeft: "Left",
    alignCenter: "Centred",
    alignRight: "Right",

    // QR Code
    qrDataSource: "QR data source",

    // Barcode
    barcodeDataSource: "Data source",
    barcodeWidthMm: "Barcode width (mm)",
    barcodeHeightMm: "Barcode height (mm)",
    barcodeDisplayValue: "Show value below barcode",

    // Allergens text
    allergenSeparator: "Separator",
    allergenSeparatorHint: "Characters between allergen names (e.g. ', ' or ' / ')",

    // Divider
    dividerLineWidth: "Line width (mm)",
    dividerLineWidthHint: "Width of the divider line",
    dividerLineThickness: "Line thickness (mm)",
    dividerLineThicknessHint: "Thickness of the line",

    // Date Base
    
    // Database Fields
    fridgeValue: "Refrigerator value",
    fridgeValueHint: "e.g. BEFORE OPENING",
    threeHours: "Three hours (YES/NO)",
    itemName: "Product name",
    
    // Offset Fields
    thawingDaysOffset: "Thawing days",
    refrigeratedDaysOffset: "Refrigeration days",
    expiryDays: "Shelf life (days)",
    thawingHours: "Thawing hours",
    refrigeratedHours: "Refrigeration hours",
    expiryHours: "Shelf life (hours)",
    showTime: "Show time",
    
    // QR Data Fields
    itemId: "Product ID",
    customUrl: "Custom URL",
    customData: "Custom data",

    // Snackbar / status messages
    labelSavedSuccess: "Label saved",
    labelSaveFailed: "Could not save label",
    labelLoadFailed: "Could not load labels",
    labelLoadSingleFailed: "Could not load the label",
    fieldOrderUpdated: "Field order updated",

    // Labels management view
    labelsDescription: "Manage your labels — view details, activate/deactivate or delete.",
    totalLabels: "Total labels",
    activeLabels: "Active labels",
    inactiveLabels: "Inactive labels",
    labelsList: "Labels",
    searchLabels: "Search labels...",
    dimensions: "Dimensions",
    inactive: "Inactive",
    color: "Colour",
    type: "Type",
    freetext: "Free text",
    viewLabel: "View label",
    noLabelsFound: "No labels found",
    createFirstLabel: "Create your first label",
    namePosition: "Name position",
    fieldLabel: "Field label",
    position: "Position",
    noFields: "No fields configured",
    hasLogo: "Logo added",
    status: "Status",
    editInDesigner: "Edit in designer",
    confirmDeleteText: "Are you sure you want to delete '{labelName}'? This cannot be undone.",
    deleteWarning: "All fields belonging to this label will be deleted too.",
    labelActivated: "'{name}' is now active",
    labelDeactivated: "'{name}' is now inactive",
    labelToggleError: "Could not change the label's status",
    labelDeleted: "'{name}' has been deleted",
    labelDeleteError: "Could not delete the label",
    close: "Close",
    deleteLabel: "Delete label",

    // device management
    devicesDescription: "Manage your devices and licences.",
    totalLicenses: "Total licences",
    usedLicenses: "Used licences",
    availableLicenses: "Available licences",
    devicesList: "Devices",
    searchDevices: "Search devices...",
    deleteDevice: "Delete device",
    noDevicesFound: "No devices found",
    noDevicesHint: "Devices register through the app.",
    deleteDeviceHint: "The device must register again before it can be used.",
    deviceDeleted: "'{name}' has been deleted",
    deviceDeleteError: "Could not delete the device",
    canEdit: "Can edit",
    cannotEdit: "Cannot edit",
    canEditProducts: "Editing",
    allowEditing: "Allow editing",
    disableEditing: "Disable editing",
    editingEnabled: "Editing enabled",
    editingDisabled: "Editing disabled",
    selected: "selected",
    updateError: "Update failed",
    canDelete: "Can delete",
    cannotDelete: "Cannot delete",
    canDeleteProducts: "Deleting",
    allowDeleting: "Allow deleting",
    disableDeleting: "Disable deleting",
    deletingEnabled: "Deleting enabled",
    deletingDisabled: "Deleting disabled",
    editingDisabledCascade: "Editing disabled — deleting was disabled too",
    deletingEnabledCascade: "Deleting enabled — editing was enabled too",
    allowBackdating: "Allow backdating",
    disallowBackdating: "Disable backdating",
    backdatingEnabled: "Backdating enabled",
    backdatingDisabled: "Backdating disabled",
    backdatingDisabledCascade: "Backdating disabled — editing was disabled too",
    backdatingEnabledCascade: "Backdating enabled — editing was enabled too",
    backdatingOff: "Backdating disabled",
    backdatingOn: "Backdating enabled",
    maxBackdateDays: "Maximum days for backdating",
    maxBackdateDaysHint: "Set how many days back a user may choose for the production/opened date. 0 disables backdating.",

    // Configurations Page
    configurations: "Configurations",
    globalSettings: "Global settings",
    globalSettingsHint: "These settings apply to every tablet on this account. Saving bumps the version so tablets fetch the new settings.",
    tabletFields: "Tablet fields",
    tabletFieldConfig: "Tablet field configuration",
    tabletFieldConfigHint: "Configure which fields are visible when creating or editing items on tablets.",
    tabletFieldConfigInfo: "Drag to reorder. Hidden fields do not appear in tablet dialogs. Required fields must be filled in before saving.",
    freetextLabels: "Free-text labels",
    freetextLabelsOverview: "Free-text labels",
    freetextLabelsHint: "All free-text labels including local tablet labels. Local labels are only visible on the device that created them.",
    noFreetextLabels: "No free-text labels found.",
    reassignToDevice: "Assign to device",
    reassignHint: "Choose a device to assign this free-text label to. It will no longer be visible on the original device.",
    labelsSelected: "{count} label(s) selected",
    targetDevice: "Target device",
    markAsLocal: "Mark as local",
    reassign: "Assign",
    moveToDevice: "Move to device",
    removeFromAll: "Remove from all devices",
    broadcastNewLabel: "Broadcast a new label to several devices",
    broadcastNew: "Create new",
    broadcast: "Publish",
    freetextContent: "Free-text content",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    selectDevices: "Select devices",
    broadcastDevices: "Send to {count}",
    devicesSelected: "{count} device(s) selected",
    pushToDevices: "Send to {count} devices",
    pushExistingHint: "Send an existing label to several devices.",
    activeBroadcasts: "Active broadcasts",
    broadcastsHint: "Free-text labels currently broadcast to several devices. They stay active until removed manually from all devices or assigned to a single device.",
    noBroadcasts: "No active broadcasts",
    valuesInDays: "days",
    valuesInHours: "hours",
    showAlias: "Show alias",
    showAliasHint: "Show the 'Alias' field on the tablet home screen beneath the product name.",
    showMenuTab: "Show menu tab",
    showMenuTabHint: "Show the active menu as a tab on the tablet home screen",
    hideCategoryAll: "Hide the 'All' category",
    hideCategoryAllHint: "Hide the 'All' category from the category menu on tablets",

    // Global Settings Toggles
    useCategoriesHint: "Show the category menu on tablets and category selection when creating items",
    usePrintDialog: "Show print dialog",
    usePrintDialogHint: "Show a dialog with date selection before labels are printed on tablets",
    showTimestampOnDates: "Show time on dates",
    showTimestampOnDatesHint: "Include an HH:MM timestamp on date labels (e.g. 17/02/26 10:30)",
    showCategoryOnProduct: "Show category on product",
    showCategoryOnProductHint: "Show the category name beneath the product name on the tablet home screen",
    todaysDateInclusive: "Today's date included",
    todaysDateInclusiveHint: "Include today in the expiry calculation (e.g. 3 days from Monday = Wednesday instead of Thursday)",
    settingsVersionInfo: "Current version",
    settingsVersionHint: "Tablets on an older version fetch the updated settings at their next refresh.",
    saveChanges: "Save changes",

    // Field Config Table
    fieldName: "Field",
    customLabel: "Custom label",
    visible: "Visible",
    required: "Required",

    // Freetext Table
    content: "Content",
    device: "Unit",
    scope: "Scope",
    updated: "Updated",
    local: "Local",
    global: "Global",
    confirmDeleteFreetext: "Are you sure you want to delete this free-text label?",
    freetextSizes: "Available sizes",
    freetextSizesHint: "List of available free-text sizes.",
    createSize: "Create size",
    createFreetextSize: "Create free-text size",
    widthMm: "Width (mm)",
    heightMm: "Height (mm)",
    freetextSizeWhiteHint: "Free-text labels are shown in white",
    default: "Default",
    setAsDefault: "Set as default",
    cancelDefault: "Clear default",

    // Location management
    locationName: "Location name",
    assignUser: "Assign user",
    assignedUsers: "Assigned users",
    noUsersAssigned: "No users assigned",
    addUsers: "Add users",
    selectUsers: "Select users",
    assignProducts: "Assign products",
    assignedProducts: "Assigned products",
    availableProducts: "Available products",
    noProductsAssigned: "No products assigned",
    allProductsAssigned: "All products assigned",
    countryCode: "Country code",
    timezone: "Time zone",
    createdLocation: "Location created",
    editLocation: "Edit location",
    totalLabelsPrinted: "Total labels printed",
    clickForBreakdown: "Click for a detailed breakdown",
    printStatsTitle: "Print statistics",
    noPrintEvents: "No print statistics found for any location",
    labelsPrintedTotal: "labels printed in total",
    since: "since",
    createLocation: "Create location",

    //Tickets System
    createTicket: "Create ticket",
    ticketType: "Ticket type",
    ticketTypeSale: "Sales",
    ticketTypeSupport: "Support",
    ticketTypeBug: "Bug report",
    ticketTitle: "Title",
    ticketDescriptionHint: "Describe your problem or request in detail",
    ticketReporter: "Reporter",
    ticketCreated: "Ticket created",
    priority: "Priority",
    priorityHint: "Leave blank and let the system decide from the ticket's content, or choose manually",
    priorityAuto: "Auto",
    priorityLow: "Low",
    priorityMedium: "Medium",
    priorityHigh: "High",
    priorityUrgent: "Urgent",
    submit: "Submit ticket",
    tickets: "Tickets",
    orderAccessories: "Order labels & accessories",
    ticketLogHint: "List of support requests sent to Capture IT.",

    impersonation: {
        menuItem: "Enter a customer account",
        title: "Enter a customer account",
        subtitle: "Pick a customer to work inside their account. Everything you do happens to their real data.",
        search: "Search by customer, account number or email...",
        customer: "Customer",
        lastPrint: "Last printed",
        enter: "Enter",
        noCustomers: "No customers found",
        loadFailed: "Could not load the customer list",
        confirmTitle: "Enter this customer's account?",
        confirmText: "You are about to open {customer}'s account with their own administrator's permissions.",
        confirmWarning: "Everything you do happens to the customer's real data. The session is logged and expires automatically after 2 hours.",
        bannerTitle: "You are working inside {customer}'s account",
        bannerSubtitle: "Signed in as yourself ({user}) underneath",
        stop: "Leave",
    },

    designer: {
        untitled: "Untitled",
        noLabel: "No label selected",
        saved: "Saved",
        saveError: "Could not save",
        unsavedTitle: "Unsaved changes",
        unsavedConfirm: "You have unsaved changes. Leave the page?",
        leaveAnyway: "Leave anyway",
        stay: "Stay",
        toggleGrid: "Toggle grid",
        preview: "Preview",
        undo: "Undo",
        redo: "Redo",
        save: "Save",
        print: "Print",
        back: "Back",
    },
    fields: {
        productFields: "Product fields",
        productField: "Product field",
        barcodes: "Barcodes",
        layout: "Layout",
        qrCode: "QR code",
        staticText: "Static text",
        imageLogo: "Logo image",
        divider: "Divider",
        productNumber: "Product number",
        productName: "Product name",
        description: "Description",
        costPrice: "Cost price",
        salesPrice: "Sales price",
        currency: "Currency",
    },
    common: {
        none: "None",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        close: "Close",
        edit: "Edit",
        copy: "Copy",
        unsaved: "Unsaved changes",
        loading: "Loading...",
        error: "Error",
        success: "Success",
    },
    label: {
        name: "Label name",
        width: "Width (mm)",
        height: "Height (mm)",
        color: "Colour",
        colour: "Colour",
        type: "Type",
        grid: "Grid",
        gridSize: "Grid size (mm)",
        active: "Active",
        unit: "Unit",
        mm: "mm",
        inch: "inch",
    },
    canvas: {
        grid: "Show grid",
        gridSize: "Grid size (mm)",
        layers: "Layers",
        noElements: "No elements",
    },
    importFromOld: "Import from the old system",
    selectLabelsToImport: "Select labels to import",
    importHint: "Labels are imported into the new system. The original is kept.",
    importCount: "Import {n} label(s)",
    newDesign: "New label",
    designs: "Labels",
    searchDesigns: "Search labels...",
    totalDesigns: "Total labels",
    activeDesigns: "Active labels",
    inactiveDesigns: "Inactive labels",
    designCreated: "Label created",
    designCopied: "Label copied",
    designDeleted: "Label deleted",
    designsDeleted: "Labels deleted",
    deleteDesign: "Delete label",
    deleteDesignConfirm: "Are you sure you want to delete '{name}'?",
    bulkDelete: "Delete selected",
    bulkDeleteConfirm: "Are you sure you want to delete {n} labels?",
    errorCreating: "Could not create the label",
    errorUpdating: "Could not update the label",
    errorCopying: "Could not copy the label",
    errorDeleting: "Could not delete the label",
    errorLoading: "Could not load labels",
    importSuccess: "{n} label(s) imported",
    importError: "Import error",
    labelsSubtitle: "Manage your labels",
    roundExpiryDownToQuarter: "Round the expiry time down to the nearest quarter hour",
    roundExpiryDownToQuarterHint: "Only when shelf life is in hours. An expiry at 16:07 shows as 16:00 — always down, so the shelf life is never exceeded",
    // Shown on the colour swatch in the product list when the
    // product prints with something other than its own label.
    labelInactiveFallback: "The label \"{label}\" is inactive — printing with \"{fallback}\"",
    labelMissingFallback: "No label selected — printing with \"{fallback}\"",

    // Bulk deletion of categories, including the "these still
    // contain products — move them where?" second step.
    confirmBulkDeleteCategories: "Delete the selected categories?",
    bulkDeleteWarning: "This cannot be undone.",
    categoriesInUseTitle: "Categories still in use",
    categoriesInUseText: "These categories still contain products:",
    moveProductsTo: "Move the products to",
    moveAndDelete: "Move and delete",
    noReassignTarget: "Every category is selected. Deselect at least one to move the products into.",
    categoriesDeleted: "categories deleted",
    productsMoved: "products moved",
    defaultCategorySkipped: "the default category was skipped",
    bulkDeleteFailed: "Deletion failed",

    totalLocations: "Total locations",

    productImage: "Product image",
    chooseFromLibrary: "Choose from library",
    changeImage: "Change image",
    productImageHint: "Shown on the tablet instead of the product name, if image display is on",
    productImageLibrary: "Image library",

    productImages: {
        libraryTitle: "Image library",
        libraryHint: "Upload all your product images at once, then pick them onto products afterwards.",
        uploadButton: "Upload images",
        deleteSelected: "Delete selected",
        uploadProgress: "Uploading",
        alreadyInLibrary: "Already in the library",
        noImages: "No images yet",
        preview: "Preview",
        name: "Name",
        dimensions: "Size",
        usedBy: "Used by",
        uploaded: "Uploaded",
        uploadSummary: "{n} images uploaded",
        uploadSummaryFailed: "{n} uploaded, {failed} failed",
        uploadSummaryDuplicates: "{n} uploaded, {duplicates} skipped as duplicates",
        imageRenamed: "Image renamed",
        renameFailed: "Could not rename the image",
        confirmDeleteImage: "Are you sure you want to delete this image?",
        deleteImageInUseWarning: "{n} products use this image and will lose it.",
        imageDeleted: "Image deleted",
        imageDeletedInUse: "Image deleted — the products that used it now have none",
        deleteFailed: "Could not delete the image",
        confirmBulkDelete: "Confirm deletion",
        confirmBulkDeleteText: "Are you sure you want to delete {n} images?",
        selectedInUseWarning: "{n} of the selected images are in use and will be lost on the products using them.",
        andMoreCount: "… and {n} more",
        deleteAll: "Delete all",
        imagesDeletedSummary: "{n} images deleted",
        imagesDeletedMissing: "{n} images deleted ({missing} not found)",
        bulkDeleteFailed: "Could not delete the images",

        picker: {
            title: "Choose image",
            uploadNew: "Upload new",
            search: "Search images...",
            empty: "There are no images in the library yet. Upload some to get started.",
            noMatch: "No images match your search",
            removeImage: "Remove image",
            uploadFailedCount: "{n} images could not be uploaded",
        },
    },
    showProductImages: "Show product images",
    showProductImagesHint: "Show product images on the tablet home screen.",
    showProductNames: "Show product names",
    showProductNamesHint: "Show product names on the tablet home screen.",

    productDisplayMode: "Product display",
    displayModeText: "Names",
    displayModeImage: "Images",
    displayModeUser: "User's choice",
    mixed: "Mixed",
    noDevicesUpdated: "No devices were updated",
    customFields: "Custom fields",
    customFieldsHint: "Add fields to show specific product information",
    noCustomFields: "No custom fields",
    editField: "Edit field",
    fieldLabelHint: "Label for the field",
    fieldPrefixHint: "Prefix for the field",
    fieldKeyFixedHint: "Key for the field (cannot be changed)",
    deleteFields: "Delete fields",
    deleteFieldsWarning: "This permanently deletes the selected fields",
    deactivateInsteadHint: "Deactivate instead of deleting",
    fieldsDeleted: "Fields deleted",
    valuesRemoved: "Values removed",
    storedValues: "Stored values",
    printedPrefix: "Printed prefix",
    prefix: "Prefix",
    fieldKey: "Field key",
    values: "Values",
    sortOrder: "Sort order",
    labelRequired: "Label is required",

    ...designerI18n.en,
}